import {
  Component,
  ElementRef,
  Renderer2,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MainService } from '../main/service/mainservice';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../components/login/service/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotifierService } from '../../../services/Notifierservice';
import { DashboardService } from './dashboard.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DialogService } from '../../../services/dialog.service';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  private readonly notifier: NotifierService;
  myOptions: any;
  bodySpinner: boolean = false;
  allowedApps: any[] = [];
  allApps: any[] = [];
  isModalVisible: boolean = false;
  metricFullscreen: boolean = true;
  popLoader: boolean = false;
  listSearch: any = '';
  userListData: any[] = [];
  pageNo: number = 0;
  limit: number = 1000;
  userListPayload: any;
  total_pages: number = 0;
  userForm: FormGroup = new FormGroup({});
  userselectedId: any = null;
  modelType: string = '';
  submitted: boolean = false;
  initContry: any;
  roleList: any[] = [];
  spinner: boolean = false;
  countryCode2: any;
  countryCode1: any;
  loggedInRole: any;
  loginedUserDetails: any;
  formattedValue: any;
  initialCountryCode: any;
  userDetailInput: any;
  @ViewChild('intlInput') intlInput!: ElementRef;
  @ViewChild('phoneComp') phoneComp!: PhoneNumberInputComponent;
  constructor(
    private readonly mainService: MainService,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly service: LoginService,
    private readonly notifierService: NotifierService,
    private readonly dashboardService: DashboardService,
    private readonly renderer: Renderer2,
    private readonly dialogService: DialogService,
  ) {
    this.bodySpinner = true;
    this.notifier = notifierService;
  }

  ngOnInit() {
    // ✅ Initialize form FIRST before any async calls
    this.userForm = this.fb.group({
      company_name: [''],
      location: [''],
      username: [
        '',
        [Validators.required, Validators.pattern(/\S/)],
      ],
      first_name: [''],
      last_name: [''],
      middle_name: [''],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],
      userid: [''],
      role: ['', Validators.required],
      doj: [''],
      empid: [''],
      phone_number: ['', [Validators.required]],
      password: [''],
      apps: [null, [Validators.required]],
    });

    // Now safe to make API calls
    this.dashboardService.getCurrentUser().subscribe({
      next: (response: any) => {
        this.allowedApps = response?.['apps'];
        this.allApps = response?.['all_apps'];
        this.loggedInRole = response['role'];
        if (
          ['admin', 'super admin'].includes(this.loggedInRole?.toLowerCase())
        ) {
          this.getUserRoles();
        }
        this.loginedUserDetails = response;
        this.bodySpinner = false;
      },
      error: (errors: HttpErrorResponse) => {
        this.bodySpinner = false;
      },
    });

    this.myOptions = {
      /* ...same as before... */
    };

    this.pageNo++;
    this.userListPayload = {
      filters: [],
      page: this.pageNo,
      per_page: this.limit,
      sort_by: 'email',
      sort_order: 'desc',
    };
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  selectedApps(data: any) {
    let appsList = [
      {
        text: 'Post Call Analytics and Process Automation',
        icon: 'bi bi-telephone',
        url: '/main/postcall/audioRecords',
        name: 'audio',
      },
      {
        text: 'Voice Mail Analytics and Process Automation',
        icon: 'bi bi-soundwave',
        url: '/main/voiceMailRecords',
        name: 'voiceMail',
      },
      {
        text: 'IVR Analytics and Process Automation',
        icon: 'bi bi-telephone',
        url: '/main/ivrRecords',
        name: 'ivr',
      },
      {
        text: 'E-mail Analytics and Process Automation',
        icon: 'bi bi-envelope',
        url: '/main/email/autoEmailRecords',
        name: 'email',
      },
      {
        text: 'Survey Analytics and Process Automation',
        icon: 'bi bi-clipboard-data',
        url: '/main/surveyRecords',
        name: 'survey',
      },
      {
        text: 'Text Analytics and Process Automation',
        icon: 'bi bi-clipboard-data',
        url: '/main/textRecords',
        name: 'text',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/doc-analytics',
        name: 'document',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/contracts',
        name: 'contract',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/rfpcontracts',
        name: 'rfpcontract',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-shield-lock',
        url: '/main/infosecurity',
        name: 'infosecurity',
      },
      {
        text: 'AI Assistance',
        icon: 'bi bi-robot',
        url: 'https://gpt.absenceassistance.com',
        name: 'ai-assist',
      },
      {
        text: 'BI Reports and Analytics',
        icon: 'bi bi-graph-up-arrow',
        url: 'https://reports.canstringai.com:8443/timebound/#/',
        name: 'reports',
      },
    ];

    if (data == 'ai-assist') {
      window.open('https://gpt.absenceassistance.com', 'target=_blank');
      return;
    }
    if (data == 'reports') {
      window.open(
        'https://reports.canstringai.com:8443/timebound/#/',
        'target=_blank',
      );
      return;
    }

    if (data == 'social-media') {
      return;
    }
    let selected = appsList.filter((list) => list['name'] == data);
    this.router.navigateByUrl(selected[0]['url']);

    localStorage.setItem('selectedApps', selected[0]['name']);
    this.mainService.selectedAppsBS.next(selected[0]);
  }

  clearStorage() {
    try {
      const raw = localStorage.getItem('user');

      if (!raw) {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['login']);
        return;
      }

      // Match exactly how navigateToDashboard stores it:
      // saltHex::ivHex::ciphertext
      const parts = raw.split('::');
      if (parts.length !== 3) {
        throw new Error('Unexpected storage format');
      }

      const [saltHex, ivHex, cipherStr] = parts;

      const salt = CryptoJS.enc.Hex.parse(saltHex);
      const iv = CryptoJS.enc.Hex.parse(ivHex);
      const key = CryptoJS.PBKDF2(this.service.enCryptKey, salt, {
        keySize: 32,
        iterations: 128,
        hasher: CryptoJS.algo.SHA256,
      });

      const decrypted = CryptoJS.AES.decrypt(cipherStr, key, { iv });
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
        throw new Error('Decryption produced empty result');
      }

      const userDetails = JSON.parse(decryptedString);

      this.service.logout(userDetails['userid']).subscribe({
        next: () => {
          this.notifier.notify('default', 'You are successfully logged out');
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['login']);
        },
        error: () => {
          // Still log out client-side even if API fails
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['login']);
        },
      });
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['login']);
    }
  }

  isAllowed(appName: string) {
    if (this.allowedApps?.length > 0) {
      let index = this.allowedApps.findIndex(
        (list: any) => list['name'].toLowerCase() == appName.toLowerCase(),
      );
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  closeModal() {
    this.isModalVisible = false;
  }

  OpenModel(modal: string) {
    this.isModalVisible = true;
    this.userListData = [];
    this.getUserList();
  }

  getUserRoles() {
    this.dashboardService.getuserRoleList().subscribe((res: any) => {
      this.roleList = res;
    });
  }

  getUserList() {
    this.dashboardService.getUserList(this.userListPayload).subscribe({
      next: (response: any) => {
        this.userListData = [...response['data']];
        if (this.userListData.length > 0) {
          this.selectUser(this.userListData[0]);
        }
        this.total_pages = response['pagination']['total_pages'];
      },
      error: (errors: HttpErrorResponse) => {
        this.userListData = [];
      },
    });
  }

  searchUser() {
    this.userListPayload['filters'] = {
      property: 'username',
      operator: 'eq',
      value: this.listSearch,
    };

    this.getUserList();
  }

  selectUser(user: any) {
    this.userDetailInput = user;
    this.userselectedId = user['id'];
    this.modelType = 'edit';

    // Map name strings → numeric IDs to match [value]="app.id" in template
    const appIds = (user?.apps ?? [])
      .map((entry: any) => {
        if (typeof entry === 'object' && entry?.id != null) return entry.id;
        const match = this.allApps.find(
          (a: any) => a.name?.toLowerCase() === String(entry).toLowerCase(),
        );
        return match?.id ?? null;
      })
      .filter((id: any) => id !== null);

    this.userForm.patchValue({ ...user, apps: appIds });

    setTimeout(() => {
      if (['super admin'].includes(user?.role?.toLowerCase())) {
        this.userForm
          .get('role')
          ?.disable({ emitEvent: false, onlySelf: true });
      } else {
        this.userForm.get('role')?.enable({ emitEvent: false, onlySelf: true });
        this.userForm.get('apps')?.enable({ emitEvent: false, onlySelf: true });
      }
    }, 0);
  }

  onNearEndScroll() {
    if (this.pageNo < this.total_pages) {
      this.pageNo++;
      this.getUserList();
    }
  }

  newUser() {
    this.userForm.get('role')?.enable();
    this.userForm.get('apps')?.enable();
    this.submitted = false;
    this.userForm.reset();
    this.userselectedId = null;
    this.userForm.patchValue({ phone_number: '' });
    setTimeout(() => this.phoneComp.reset('US'));
  }

  onSubmit() {
    if (this.spinner) return;
    this.submitted = true;
    this.userForm.markAllAsTouched();
    this.userForm.markAsDirty();

    if (this.userForm.valid) {
      this.spinner = true;
      const rawValue = this.userForm.getRawValue();

      if (this.userselectedId == null) {
        this.dashboardService
          .addUser({ ...rawValue, apps: rawValue.apps })
          .subscribe({
            next: () => {
              this.spinner = false;
              this.notifier.notify('default', 'Created successfully');
              this.getUserList();
            },
            error: () => {
              this.spinner = false;
            },
          });
      } else {
        const formObject = {
          username: rawValue.username,
          role: rawValue.role,
          email: rawValue.email,
          phone_number: rawValue.phone_number,
          apps: rawValue.apps,
          id: this.userselectedId,
        };
        this.dashboardService.updateUser(formObject).subscribe({
          next: () => {
            this.spinner = false;
            this.notifier.notify('default', 'Updated successfully');
            this.getUserList();
          },
          error: () => {
            this.spinner = false;
          },
        });
      }
    }
  }

  pressCancel() {
    //future cancel implementation
  }

  onInputPhoneChange(event: any) {
    if (event.target.value.length > 17) {
      event.preventDefault();
      let input = event.target.value;
      this.formattedValue = input.slice(0, 17);
    }
  }

  deactivateUserFun(Userdata: any) {
    if (this.spinner) return; 
    let formObject: any = {};
    if (Userdata.is_active) {
      this.dialogService.openConfirmDialog('', {
        title: 'Confirm',
        message: 'Are you sure you want to Deactivate this user?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            formObject['id'] = Userdata['id'];
            formObject['is_active'] = Userdata.is_active ? false : true;
            this.spinner = true;
            this.dashboardService.updateUser(formObject).subscribe({
              next: (response: any) => {
                this.spinner = false;
                this.notifier.notify('default', 'Updated successfully');
                this.userDetailInput['is_active'] = false;
              },
              error: (errors: HttpErrorResponse) => {
                this.spinner = false;
              },
            });
          }
        },
      });
    } else {
      this.dialogService.openConfirmDialog('', {
        title: 'Confirm',
        message: 'Are you sure you want to activate this user?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            formObject['id'] = Userdata['id'];
            formObject['is_active'] = Userdata.is_active ? false : true;

            this.spinner = true;
            this.dashboardService.updateUser(formObject).subscribe({
              next: (response: any) => {
                this.spinner = false;
                this.notifier.notify('default', 'Updated successfully');
                this.userDetailInput['is_active'] = true;
              },
              error: (errors: HttpErrorResponse) => {
                this.spinner = false;
              },
            });
          }
        },
      });
    }
  }

  deleteUserFun(userDetailInput: any) {
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to delete this user?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.dashboardService.deleteUser(userDetailInput['id']).subscribe({
            next: (response: any) => {
              this.notifier.notify('default', 'User deleted successfully');
              this.getUserList();
            },
            error: (erors: HttpErrorResponse) => {},
          });
        }
      },
    });
  }

  compareApps(a: any, b: any): boolean {
    return String(a) === String(b);
  }
}
